import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import imagen from './quienes-somos.jpg'
import './App.css';

class QuienesSomos extends Component {
	render() {
		return (
			<Fragment>
				<div className="nav">
					<div className="nav-bar">
						<ul className="nav-list">
							<li><Link to="/">Inicio</Link></li>
							<li><Link to="/quienes-somos" className="active">Quienes somos</Link></li>
							<li><Link to="/sobre-nosotros">Sobre nosotros</Link></li>
						</ul>
					</div>
				</div>
				<div className="main-wrapper">
					<div className="main">
						<div className="static-banner mb-3">
							<img className="img-fluid" src={imagen} alt="quienes somos img" />
						</div>
						<div>
							<p>Celtia XXI es el nuevo proyecto que inició en 2011 nuestro socio fundador, dedicado al comercio mayorista de materiales para la construcción desde 1983, para ofrecer un modelo de gestión comercial más acorde con los retos que plantea el mercado en la actualidad.</p>
							<p>La oferta de productos está determinada por las necesidades del cliente, y para satisfacerla contamos con una extensa base de datos de proveedores de confianza avalada por la experiencia comercial que tenemos con ellos.</p>
							<p>Los suministros los realizamos directamente desde fábrica hasta obra, habitualmente en cargas completas, pero también tenemos la posibilidad de agruparlas con otras mercancías u otros destinatarios para que la incidencia del transporte en el precio final no encarezca el producto.</p>
							<p>La disponibilidad de precios muy competitivos de operadores logísticos con quienes llevamos muchos años relacionándonos y habiendo transportado grandes volúmenes de carga también nos permite poner este servicio a disposición de nuestros clientes adaptándolos a sus necesidades.</p>
							<p>Estudiar propuestas de compra de nuevos productos es una actividad por la que sentimos una especial predilección, ya que es un reto que pone a prueba nuestra capacidad negociadora y nos aporta conocimiento del sector.</p>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default QuienesSomos;


// WEBPACK FOOTER //
// ./src/QuienesSomos.jsx